import { render, staticRenderFns } from "./ContractorRegisteredInInactiveRegion.vue?vue&type=template&id=218aa434&"
import script from "./ContractorRegisteredInInactiveRegion.vue?vue&type=script&lang=js&"
export * from "./ContractorRegisteredInInactiveRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports